import RO from "country-flag-icons/react/3x2/RO";
import GB from "country-flag-icons/react/3x2/GB";

export type FlagCode = "RO" | "GB";

export type FlagIconProps = {
  code: FlagCode;
  className?: string;
};

export function FlagIcon({code, className}: FlagIconProps) {
  if(code === "RO") return <RO className={className} aria-hidden="true" />;
  return <GB className={className} aria-hidden="true" />;
}
